import { Action } from "@ngrx/store";
import { ReduxAction } from "./redux.action";
import { UtilService } from "../services";
import { Patient } from "../models";

export class SetPatientAction implements ReduxAction {
  type: string = "SET_FULL_PATIENT";
  patient: Patient;
  constructor(patient: Patient, private utilService: UtilService) {
    this.patient = patient;
    this._setPatientDob();
    this._setPatientBillTo();
    this._setPatientPhone();
    this._setPatientIncomplete();
    this.patient.Gender = patient.Gender || null;
    this.patient.MiddleName = patient.MiddleName || null;
    this.patient.Suffix = patient.Suffix || null;
  }

  get() {
    return this.patient;
  }

  private _setPatientIncomplete() {
    this.patient.Incomplete = !(
      this.patient.FirstName &&
      this.patient.LastName &&
      this.patient.Gender &&
      this.patient.Address1 &&
      this.patient.City &&
      this.patient.State &&
      this.patient.Zip &&
      this.patient.Phone &&
      this.patient.BillTo &&
      this.patient.Provider &&
      this.patient.PolicyId
    );
  }

  private _setPatientDob() {
    if (
      this.patient.BirthYear &&
      this.patient.BirthMonth &&
      this.patient.BirthDay
    ) {
      this.patient.Dob = this.utilService.formatDate(
        this.patient.BirthYear,
        this.patient.BirthMonth,
        this.patient.BirthDay
      );
    }
    let dob = this.patient.Dob || "";
    let ar = dob.split("-");
    this.patient.BirthYear = ar[0] || null;
    this.patient.BirthMonth = ar[1] || null;
    this.patient.BirthDay = Number(ar[2]) || null;
  }

  private _setPatientBillTo() {
    if (
      this.patient.BillTo &&
      this.patient.BillTo.length > 0 &&
      ["Commercial", "Medicare-Part B", "Patient"].indexOf(
        this.patient.BillTo
      ) === -1
    ) {
      this.patient.BillToText = this.patient.BillTo;
      this.patient.BillTo = "Clinic / Facility";
    } else {
      this.patient.BillToText = null;
    }
  }

  private _setPatientPhone() {
    this.patient.Phone = this.patient.Phone || "";
    this.patient.Phone = this.patient.Phone.replace(/[^0-9]/g, "");
    if (this.patient.Phone.length === 10) {
      this.patient.Phone = [
        this.patient.Phone.substr(0, 3),
        this.patient.Phone.substr(3, 3),
        this.patient.Phone.substr(6)
      ].join("-");
    }
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/actions/patient.actions.ts